// Copyright 2026. WebPros International GmbH. All rights reserved.

import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '@plesk/ui-library';
import {
    CardHeaderContainer,
    CardHeaderText,
} from 'admin/dashboard/components/Styles';

interface IProps {
    children: ReactNode;
    to?: string;
}

export default function CardHeader({
    children,
    to,
}: IProps) {
    return (
        <CardHeaderContainer>
            <CardHeaderText>
                {children}
            </CardHeaderText>

            {!!to && (
                <Link to={to}>
                    <Icon name="arrow-right" />
                </Link>
            )}
        </CardHeaderContainer>
    );
}
